<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1">1. Seeds of Dissent</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. Summer of 1953</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. The Truth</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. A Town Torn Apart</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Finding Fault</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. Requiem</span></p>
<p class="toc1"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliographical_Note" title="Link target outside of Sample">Bibliographical Note</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?441e63f9